/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


const mutations = {

/*
  {
    "recorded": {
      "progress": {
        "step1": false,
        "step2": false
      },
      "businessInfo": {
        "businessName": "",
        "country": {
          "name": "",
          "alpha2": "",
          "alpha3": ""
        },
        "businessContact": {
          "intlCode": "",
          "localNumber": ""
        },
        "businessEmail": "",
        "webAddress": ""
      },
      "mainUser": {
        "firstName": "",
        "lastName": "",
        "contactNumber": "",
        "emailAddress": ""
      },
      "users": [],
      "socialMediaReviews": {
        "facebook": "",
        "twitter": "",
        "googleMaps": "",
        "trustPilot": "",
        "g2": "",
        "capterra": "",
        "tripAdvisor": "",
        "yelp": "",
        "fourSquare": "",
        "chooseFbS": false,
        "chooseFbR": false,
        "chooseTw": false,
        "chooseGP": false,
        "chooseTP": false,
        "chooseG2": false,
        "chooseCT": false,
        "chooseTA": false,
        "chooseYE": false,
        "chooseFS": false
      },
      "needHelpSocialReviews": false,
      "needHelpLogoColor": false,
      "feedbackAddressHandle": "",
      "appearance": {
        "logoUrl": "",
        "backgroundHex": {
          "hsl": {
            "h": 279.7333333333333,
            "s": 0,
            "l": 0,
            "a": 1
          },
          "hex": "#000000",
          "rgba": {
            "r": 0,
            "g": 0,
            "b": 0,
            "a": 1
          },
          "hsv": {
            "h": 279.7333333333333,
            "s": 0,
            "v": 0,
            "a": 1
          },
          "oldHue": 279.7333333333333,
          "source": "hsva",
          "a": 1
        }
      },
      "subscriptionType": ""
    },
    "view": {
      "currentStep": 1,
      "modals": {
        "socialMediaHelp": false
      },
      "initialSetup": ""
    }
  }


  {
  "validLoggedInLoaded": true,
  "loggedInUser": {
    "authID": "2MPS2ywtlubyWS5eCYrXIjsw6vZ2",
    "firstName": "",
    "lastName": "",
    "emailAddress": "",
    "contactNumber": "",
    "lastAccessed": 1608192388,
    "entityDocID": "6t42bmEuZOe2MPS2ywtlubyWS5eCYrXIjsw6vZ2jmCY6B1603797154"
  },
  "viewData": {
    "planFeatures": {
      "learn": {
        "base": [
          "200 email invites/month",
          "100 Text (SMS) invites/month",
          "100 feedback responses/month",
          "3 Survey questions"
        ],
        "extra": []
      },
      "engage": {
        "base": [
          "1,000 email invites/month",
          "500 Text (SMS) invites/month",
          "1,000 feedback responses/month",
          "5 Survey questions"
        ],
        "extra": [
          "Capture customer contact details",
          "Turn off Feedback Link branding",
          "Direct links"
        ]
      },
      "soar": {
        "base": [
          "2,500 email invites/month",
          "1,500 Text (SMS) invites/month",
          "5,000 feedback responses/month",
          "8 Survey questions"
        ],
        "extra": [
          "Capture customer contact details",
          "Turn off Feedback Link branding",
          "Direct links",
          "Custom web address/domain"
        ]
      },
      "streamline": {
        "base": [],
        "extra": []
      }
    },
    "feedbackEmpty": false,
    "isNewUser": true,
    "business": {
      "dateCreated": 1603797154,
      "devKey": "lMOqJKxDHoLktkBe6t42bmEuZOe2MPS2ywtlubyWS5eCYrXIjsw6vZ2jmCY6B1603797154",
      "businessID": "6t42bmEuZOe2MPS2ywtlubyWS5eCYrXIjsw6vZ2jmCY6B1603797154",
      "unhappyLink": "f76",
      "feedbackAddressHandle": "ffff",
      "uAccess": "1bcIq2MPS2ywtlubyWS5eCYrXIjsw6vZ2aLDSlj9",
      "needHelp": {
        "logoColor": false,
        "socialMediaReviews": false
      },
      "askCustomerDetail": true,
      "rAccess": "oYqZm2MPS2ywtlubyWS5eCYrXIjsw6vZ2Lun7h",
      "questionQuota": 5,
      "notificationPreferences": {
        "email": "wef33@112.xom",
        "period": "w",
        "recieveProductUpdatesTips": true
      },
      "askWhy": true,
      "businessInfo": {
        "businessEmail": "eee@ww.com",
        "businessContact": {
          "localNumber": "",
          "intlCode": ""
        },
        "webAddress": "",
        "businessName": "ewf",
        "country": {
          "alpha3": "",
          "alpha2": "",
          "name": ""
        }
      },
      "happyLink": "a0a",
      "happyCustomersShare": true,
      "is2020": true,
      "publicFeedbackDetail": {
        "unhappyLink": "f76",
        "activeQuestions": [],
        "entityInfo": {
          "businessContact": {
            "localNumber": "",
            "intlCode": ""
          },
          "webAddress": "",
          "businessEmail": "eee@ww.com",
          "country": {
            "alpha2": "",
            "alpha3": "",
            "name": ""
          },
          "businessName": "ewf"
        },
        "uAccess": "ZY7tb90oS2MPS2ywtlubyWS5eCYrXIjsw6vZ2nnff7sX48",
        "handles": [
          "a0a",
          "f76",
          "ffff"
        ],
        "socialMedia": {
          "FbRActivated": null,
          "chooseTA": true,
          "chooseYE": false,
          "chooseTP": false,
          "TPActivated": null,
          "TwActivated": null,
          "G2Activated": null,
          "capterra": "",
          "chooseGP": false,
          "googleMaps": "",
          "chooseTw": true,
          "CTActivated": null,
          "tripAdvisor": "",
          "trustPilot": "",
          "yeActivated": null,
          "yelp": "",
          "TAActivated": false,
          "chooseFbR": false,
          "GPActivated": null,
          "g2": "",
          "twitter": "wefew2",
          "fourSquare": "",
          "chooseFS": false,
          "FbSActivated": null,
          "facebook": "",
          "chooseFbS": false,
          "chooseCT": false,
          "FSActivated": null,
          "chooseG2": false
        },
        "businessID": "6t42bmEuZOe2MPS2ywtlubyWS5eCYrXIjsw6vZ2jmCY6B1603797154",
        "feedbackAddressHandle": "ffff",
        "askWhy": true,
        "happyLink": "a0a",
        "is2020": true,
        "for": "2MPS2ywtlubyWS5eCYrXIjsw6vZ2",
        "appearanceInfo": {
          "logoUrl": "",
          "backgroundHex": {
            "rgba": {
              "a": 1,
              "r": 0,
              "b": 0,
              "g": 0
            },
            "hsv": {
              "s": 0,
              "a": 1,
              "h": 279.7333333333333,
              "v": 0
            },
            "hex": "#000000",
            "a": 1,
            "oldHue": 279.7333333333333,
            "hsl": {
              "s": 0,
              "l": 0,
              "h": 279.7333333333333,
              "a": 1
            },
            "source": "hsva"
          }
        },
        "negativeShareReview": false
      },
      "businessName": "ewf",
      "showFBLLogo": true
    },
    "sentimentSummary": {
      "type": "30day",
      "old": 70,
      "new": 74
    },
    "textInviteRecord": false,
    "emailInviteRecord": false,
    "users": [],
    "forwardContacts": [],
    "inActiveQuestions": [],
    "activeQuestions": [],
    "questions": [],
    "viewFeedback": {
      "collection": [
        {
          "isFromWeb": false,
          "rating": 10,
          "for": "2MPS2ywtlubyWS5eCYrXIjsw6vZ2",
          "randomString": "DZ08WeL",
          "ratingPercentage": 100,
          "sessionStartTime": 1606844797,
          "journeyFeedback": [
            {
              "type": "ratingq",
              "responseID": "anonymousGBbVwy81606844799",
              "questionID": "NPSr",
              "qNo": 1,
              "answer": 10,
              "ask": "How likely are you to recommend ewf to others?",
              "answerOptions": null,
              "visited": true,
              "time": 1606844799
            },
            {
              "visited": true,
              "answerOptions": [],
              "name": "ewf",
              "contactInfo": {
                "businessname": "ewf",
                "website": "",
                "businessID": "6t42bmEuZOe2MPS2ywtlubyWS5eCYrXIjsw6vZ2jmCY6B1603797154",
                "contactno": "",
                "email": "eee@ww.com"
              },
              "responseID": "anonymousGBbVwy81606844800",
              "time": 1606844800,
              "answer": null,
              "ask": "Please tell us more about your experience online!",
              "questionID": "SHARE",
              "type": "shareq",
              "qNo": 2,
              "socialOptions": {
                "twitter": "wefew2"
              }
            },
            {
              "type": "openq",
              "questionID": "NPSw",
              "answerOptions": null,
              "time": 1606844808,
              "responseID": "anonymousGBbVwy81606844808",
              "qNo": 3,
              "staff": true,
              "ask": "Why did you give a rating of 10?",
              "answer": "Feedback 4 en 4 en 4 en 4 en 4",
              "visited": true
            },
            {
              "answer": null,
              "questionID": "CONTACT",
              "type": "contactq",
              "qNo": 4,
              "answerOptions": [],
              "name": "ewf",
              "ask": "Can we contact you for a follow-up?"
            }
          ],
          "sessionID": "1606844808_anonymousGBbVwy8",
          "ruAccess": "ZY7tb90oS2MPS2ywtlubyWS5eCYrXIjsw6vZ2nnff7sX48",
          "isSpam": false,
          "showAllInView": false
        },
        {
          "sessionID": "1606844785_anonymous7MWenaA",
          "journeyFeedback": [
            {
              "ask": "How likely are you to recommend ewf to others?",
              "time": 1606844768,
              "answerOptions": null,
              "visited": true,
              "responseID": "anonymous7MWenaA1606844768",
              "type": "ratingq",
              "questionID": "NPSr",
              "qNo": 1,
              "answer": 10
            },
            {
              "qNo": 2,
              "answerOptions": [],
              "responseID": "anonymous7MWenaA1606844769",
              "name": "ewf",
              "contactInfo": {
                "website": "",
                "businessname": "ewf",
                "businessID": "6t42bmEuZOe2MPS2ywtlubyWS5eCYrXIjsw6vZ2jmCY6B1603797154",
                "email": "eee@ww.com",
                "contactno": ""
              },
              "answer": null,
              "visited": true,
              "socialOptions": {
                "twitter": "wefew2"
              },
              "questionID": "SHARE",
              "ask": "Please tell us more about your experience online!",
              "time": 1606844769,
              "type": "shareq"
            },
            {
              "time": 1606844785,
              "responseID": "anonymous7MWenaA1606844785",
              "ask": "Why did you give a rating of 10?",
              "type": "openq",
              "answer": "Feedback 3 en 3 en 3 en 3",
              "qNo": 3,
              "staff": true,
              "visited": true,
              "questionID": "NPSw",
              "answerOptions": null
            },
            {
              "name": "ewf",
              "answer": null,
              "answerOptions": [],
              "type": "contactq",
              "ask": "Can we contact you for a follow-up?",
              "questionID": "CONTACT",
              "qNo": 4
            }
          ],
          "sessionStartTime": 1606844766,
          "rating": 10,
          "randomString": "E9Uw2fu",
          "ruAccess": "ZY7tb90oS2MPS2ywtlubyWS5eCYrXIjsw6vZ2nnff7sX48",
          "ratingPercentage": 100,
          "for": "2MPS2ywtlubyWS5eCYrXIjsw6vZ2",
          "isFromWeb": false,
          "isSpam": false,
          "showAllInView": false
        },
        {
          "journeyFeedback": [
            {
              "type": "ratingq",
              "answerOptions": null,
              "questionID": "NPSr",
              "visited": true,
              "time": 1603825236,
              "qNo": 1,
              "responseID": "anonymousVPLUwEo1603825236",
              "answer": 10,
              "ask": "How likely would you recommend ewf to others?"
            },
            {
              "responseID": "anonymousVPLUwEo1603825238",
              "questionID": "SHARE",
              "contactInfo": {
                "contactno": "",
                "website": "",
                "businessname": "ewf",
                "businessID": "6t42bmEuZOe2MPS2ywtlubyWS5eCYrXIjsw6vZ2jmCY6B1603797154",
                "email": "eee@ww.com"
              },
              "name": "ewf",
              "socialOptions": {
                "twitter": "wefew2"
              },
              "answerOptions": [],
              "ask": "Please tell us more about your experience online!",
              "visited": true,
              "time": 1603825238,
              "qNo": 2,
              "type": "shareq",
              "answer": null
            },
            {
              "qNo": 3,
              "questionID": "NPSw",
              "type": "openq",
              "staff": true,
              "ask": "Why did you give a rating of 10?",
              "visited": true,
              "answerOptions": null,
              "answer": "I loved it yo",
              "responseID": "anonymousVPLUwEo1603825244",
              "time": 1603825244
            },
            {
              "answer": null,
              "type": "contactq",
              "answerOptions": [],
              "name": "ewf",
              "ask": "Can we contact you for a follow-up?",
              "qNo": 3,
              "questionID": "CONTACT"
            }
          ],
          "for": "2MPS2ywtlubyWS5eCYrXIjsw6vZ2",
          "sessionStartTime": 1603825232,
          "rating": 10,
          "sessionID": "1603825238_anonymousVPLUwEo",
          "isFromWeb": false,
          "ratingPercentage": 100,
          "randomString": "BDZ2VWW",
          "ruAccess": "ZY7tb90oS2MPS2ywtlubyWS5eCYrXIjsw6vZ2nnff7sX48",
          "isSpam": false,
          "showAllInView": false
        },
        {
          "sessionStartTime": 1603825092,
          "randomString": "AwVpFSj",
          "isFromWeb": false,
          "ratingPercentage": 100,
          "ruAccess": "ZY7tb90oS2MPS2ywtlubyWS5eCYrXIjsw6vZ2nnff7sX48",
          "sessionID": "1603825097_anonymous1ZvWEUZ",
          "for": "2MPS2ywtlubyWS5eCYrXIjsw6vZ2",
          "rating": 10,
          "journeyFeedback": [
            {
              "ask": "How likely would you recommend ewf to others?",
              "responseID": "anonymous1ZvWEUZ1603825095",
              "answer": 10,
              "time": 1603825095,
              "visited": true,
              "type": "ratingq",
              "answerOptions": null,
              "qNo": 1,
              "questionID": "NPSr"
            },
            {
              "contactInfo": {
                "email": "eee@ww.com",
                "businessID": "6t42bmEuZOe2MPS2ywtlubyWS5eCYrXIjsw6vZ2jmCY6B1603797154",
                "contactno": "",
                "website": "",
                "businessname": "ewf"
              },
              "answer": null,
              "responseID": "anonymous1ZvWEUZ1603825097",
              "questionID": "SHARE",
              "ask": "Please tell us more about your experience online!",
              "time": 1603825097,
              "name": "ewf",
              "visited": true,
              "socialOptions": {
                "twitter": "wefew2"
              },
              "qNo": 2,
              "type": "shareq",
              "answerOptions": []
            },
            {
              "ask": "Why did you give a rating of 10?",
              "questionID": "NPSw",
              "qNo": 3,
              "responseID": "anonymous1ZvWEUZ1603825101",
              "visited": true,
              "type": "openq",
              "staff": true,
              "answer": "wefwe",
              "time": 1603825101,
              "answerOptions": null
            },
            {
              "qNo": 3,
              "type": "contactq",
              "name": "ewf",
              "answer": null,
              "answerOptions": [],
              "ask": "Can we contact you for a follow-up?",
              "questionID": "CONTACT"
            }
          ],
          "isSpam": false,
          "showAllInView": false
        },
        {
          "isFromWeb": false,
          "rating": 10,
          "randomString": "5zbgHom",
          "sessionStartTime": 1603824816,
          "sessionID": "1603824821_anonymousDcUG0YZ",
          "ratingPercentage": 100,
          "ruAccess": "ZY7tb90oS2MPS2ywtlubyWS5eCYrXIjsw6vZ2nnff7sX48",
          "for": "2MPS2ywtlubyWS5eCYrXIjsw6vZ2",
          "journeyFeedback": [
            {
              "ask": "How likely would you recommend ewf to others?",
              "qNo": 1,
              "visited": true,
              "type": "ratingq",
              "time": 1603824819,
              "answer": 10,
              "responseID": "anonymousDcUG0YZ1603824819",
              "questionID": "NPSr",
              "answerOptions": null
            },
            {
              "questionID": "SHARE",
              "time": 1603824821,
              "ask": "Please tell us more about your experience online!",
              "qNo": 2,
              "type": "shareq",
              "contactInfo": {
                "website": "",
                "email": "eee@ww.com",
                "businessname": "ewf",
                "contactno": "",
                "businessID": "6t42bmEuZOe2MPS2ywtlubyWS5eCYrXIjsw6vZ2jmCY6B1603797154"
              },
              "answer": null,
              "answerOptions": [],
              "responseID": "anonymousDcUG0YZ1603824821",
              "visited": true,
              "name": "ewf",
              "socialOptions": {
                "twitter": "wefew2"
              }
            },
            {
              "staff": true,
              "responseID": "anonymousDcUG0YZ1603824824",
              "ask": "Why did you give a rating of 10?",
              "answer": "hjvk",
              "questionID": "NPSw",
              "time": 1603824824,
              "qNo": 3,
              "visited": true,
              "type": "openq",
              "answerOptions": null
            },
            {
              "qNo": 3,
              "answer": null,
              "type": "contactq",
              "ask": "Can we contact you for a follow-up?",
              "questionID": "CONTACT",
              "name": "ewf",
              "answerOptions": []
            }
          ],
          "isSpam": false,
          "showAllInView": false
        },
        {
          "rating": 0,
          "ratingPercentage": 0,
          "journeyFeedback": [
            {
              "questionID": "NPSr",
              "answer": 0,
              "answerOptions": [],
              "responseID": "anonymouslMFYNqD1603821611",
              "type": "ratingq",
              "ask": "How likely would you recommend ewf to others?",
              "time": 1603821611,
              "visited": true,
              "qNo": 1
            },
            {
              "qNo": 2,
              "ask": "Why did you give a rating of 0?",
              "type": "openq",
              "time": 1603821613,
              "questionID": "NPSw",
              "responseID": "anonymouslMFYNqD1603821613",
              "visited": true,
              "answerOptions": [],
              "answer": "wefwe",
              "staff": true
            },
            {
              "answerOptions": [],
              "ask": "Can we contact you for a follow-up?",
              "answer": null,
              "name": "ewf",
              "type": "contactq",
              "questionID": "CONTACT",
              "qNo": 3
            }
          ],
          "isFromWeb": false,
          "randomString": "k2X2n9u",
          "sessionStartTime": 1603821609,
          "sessionID": "1603821613_anonymouslMFYNqD",
          "ruAccess": "ZY7tb90oS2MPS2ywtlubyWS5eCYrXIjsw6vZ2nnff7sX48",
          "for": "2MPS2ywtlubyWS5eCYrXIjsw6vZ2",
          "isSpam": false,
          "showAllInView": false
        },
        {
          "ratingPercentage": 80,
          "isFromWeb": false,
          "randomString": "IWDjmKK",
          "sessionID": "1603821595_anonymousUNPYgXf",
          "journeyFeedback": [
            {
              "answer": 8,
              "ask": "How likely would you recommend ewf to others?",
              "responseID": "anonymousUNPYgXf1603821590",
              "questionID": "NPSr",
              "type": "ratingq",
              "visited": true,
              "qNo": 1,
              "time": 1603821590,
              "answerOptions": null
            },
            {
              "time": 1603821595,
              "visited": true,
              "contactInfo": {
                "website": "",
                "businessname": "ewf",
                "email": "eee@ww.com",
                "businessID": "6t42bmEuZOe2MPS2ywtlubyWS5eCYrXIjsw6vZ2jmCY6B1603797154",
                "contactno": ""
              },
              "qNo": 2,
              "questionID": "SHARE",
              "answerOptions": [],
              "answer": null,
              "ask": "Please tell us more about your experience online!",
              "type": "shareq",
              "name": "ewf",
              "responseID": "anonymousUNPYgXf1603821595",
              "socialOptions": {
                "twitter": "wefew2"
              }
            },
            {
              "type": "openq",
              "answerOptions": null,
              "responseID": "anonymousUNPYgXf1603821599",
              "qNo": 3,
              "time": 1603821599,
              "visited": true,
              "staff": true,
              "answer": "weew",
              "questionID": "NPSw",
              "ask": "Why did you give a rating of 8?"
            },
            {
              "type": "contactq",
              "questionID": "CONTACT",
              "answer": null,
              "qNo": 3,
              "answerOptions": [],
              "name": "ewf",
              "ask": "Can we contact you for a follow-up?"
            }
          ],
          "for": "2MPS2ywtlubyWS5eCYrXIjsw6vZ2",
          "ruAccess": "ZY7tb90oS2MPS2ywtlubyWS5eCYrXIjsw6vZ2nnff7sX48",
          "sessionStartTime": 1603821587,
          "rating": 8,
          "isSpam": false,
          "showAllInView": false
        },
        {
          "randomString": "FpcUZZD",
          "sessionID": "1603812684_anonymous2UoqKwb",
          "journeyFeedback": [
            {
              "responseID": "anonymous2UoqKwb1603812682",
              "answerOptions": [],
              "questionID": "NPSr",
              "ask": "How likely would you recommend ewf to others?",
              "qNo": 1,
              "time": 1603812682,
              "visited": true,
              "answer": 5,
              "type": "ratingq"
            },
            {
              "visited": true,
              "answer": "wefwe",
              "questionID": "NPSw",
              "type": "openq",
              "answerOptions": [],
              "ask": "Why did you give a rating of 5?",
              "qNo": 2,
              "staff": true,
              "responseID": "anonymous2UoqKwb1603812684",
              "time": 1603812684
            },
            {
              "answer": null,
              "ask": "Can we contact you for a follow-up?",
              "type": "contactq",
              "qNo": 3,
              "name": "ewf",
              "questionID": "CONTACT",
              "answerOptions": []
            }
          ],
          "isFromWeb": false,
          "rating": 5,
          "sessionStartTime": 1603812680,
          "ratingPercentage": 50,
          "ruAccess": "ZY7tb90oS2MPS2ywtlubyWS5eCYrXIjsw6vZ2nnff7sX48",
          "for": "2MPS2ywtlubyWS5eCYrXIjsw6vZ2",
          "isSpam": false,
          "showAllInView": false
        },
        {
          "sessionID": "1603812659_anonymoussYy020c",
          "ruAccess": "ZY7tb90oS2MPS2ywtlubyWS5eCYrXIjsw6vZ2nnff7sX48",
          "rating": 10,
          "ratingPercentage": 100,
          "journeyFeedback": [
            {
              "visited": true,
              "qNo": 1,
              "answerOptions": null,
              "responseID": "anonymoussYy020c1603812657",
              "answer": 10,
              "ask": "How likely would you recommend ewf to others?",
              "type": "ratingq",
              "questionID": "NPSr",
              "time": 1603812657
            },
            {
              "type": "shareq",
              "qNo": 2,
              "time": 1603812659,
              "name": "ewf",
              "questionID": "SHARE",
              "answer": null,
              "socialOptions": {
                "twitter": "wefew2"
              },
              "visited": true,
              "ask": "Please tell us more about your experience online!",
              "answerOptions": [],
              "contactInfo": {
                "businessname": "ewf",
                "website": "",
                "businessID": "6t42bmEuZOe2MPS2ywtlubyWS5eCYrXIjsw6vZ2jmCY6B1603797154",
                "email": "eee@ww.com",
                "contactno": ""
              },
              "responseID": "anonymoussYy020c1603812659"
            },
            {
              "answerOptions": null,
              "responseID": "anonymoussYy020c1603812663",
              "qNo": 3,
              "answer": "New Feedback",
              "staff": true,
              "visited": true,
              "questionID": "NPSw",
              "type": "openq",
              "time": 1603812663,
              "ask": "Why did you give a rating of 10?"
            },
            {
              "name": "ewf",
              "questionID": "CONTACT",
              "ask": "Can we contact you for a follow-up?",
              "type": "contactq",
              "qNo": 3,
              "answer": null,
              "answerOptions": []
            }
          ],
          "for": "2MPS2ywtlubyWS5eCYrXIjsw6vZ2",
          "isFromWeb": false,
          "randomString": "vkZGL3L",
          "sessionStartTime": 1603812656,
          "isSpam": false,
          "showAllInView": false
        },
        {
          "sessionID": "1603812629_anonymousCx7GUe5",
          "sessionStartTime": 1603812625,
          "ratingPercentage": 100,
          "randomString": "6UHTqGD",
          "journeyFeedback": [
            {
              "visited": true,
              "questionID": "NPSr",
              "answer": 10,
              "responseID": "anonymousCx7GUe51603812628",
              "answerOptions": null,
              "time": 1603812628,
              "type": "ratingq",
              "ask": "How likely would you recommend ewf to others?",
              "qNo": 1
            },
            {
              "answerOptions": [],
              "socialOptions": {
                "twitter": "wefew2"
              },
              "answer": null,
              "responseID": "anonymousCx7GUe51603812629",
              "name": "ewf",
              "time": 1603812629,
              "type": "shareq",
              "qNo": 2,
              "contactInfo": {
                "businessID": "6t42bmEuZOe2MPS2ywtlubyWS5eCYrXIjsw6vZ2jmCY6B1603797154",
                "email": "eee@ww.com",
                "website": "",
                "contactno": "",
                "businessname": "ewf"
              },
              "questionID": "SHARE",
              "visited": true,
              "ask": "Please tell us more about your experience online!"
            },
            {
              "answerOptions": null,
              "time": 1603812631,
              "qNo": 3,
              "questionID": "NPSw",
              "visited": true,
              "responseID": "anonymousCx7GUe51603812631",
              "type": "openq",
              "answer": "wefwe",
              "staff": true,
              "ask": "Why did you give a rating of 10?"
            },
            {
              "answerOptions": [],
              "name": "ewf",
              "qNo": 3,
              "answer": null,
              "type": "contactq",
              "ask": "Can we contact you for a follow-up?",
              "questionID": "CONTACT"
            }
          ],
          "isFromWeb": false,
          "for": "2MPS2ywtlubyWS5eCYrXIjsw6vZ2",
          "rating": 10,
          "ruAccess": "ZY7tb90oS2MPS2ywtlubyWS5eCYrXIjsw6vZ2nnff7sX48",
          "isSpam": false,
          "showAllInView": false
        },
        {
          "ruAccess": "ZY7tb90oS2MPS2ywtlubyWS5eCYrXIjsw6vZ2nnff7sX48",
          "rating": 0,
          "sessionID": "1603812365_anonymousNSCHeB3",
          "randomString": "Yvpziiu",
          "sessionStartTime": 1603812361,
          "journeyFeedback": [
            {
              "responseID": "anonymousNSCHeB31603812363",
              "visited": true,
              "answerOptions": [],
              "time": 1603812363,
              "type": "ratingq",
              "qNo": 1,
              "ask": "How likely would you recommend ewf to others?",
              "answer": 0,
              "questionID": "NPSr"
            },
            {
              "staff": true,
              "responseID": "anonymousNSCHeB31603812365",
              "time": 1603812365,
              "answer": "ewfe",
              "ask": "Why did you give a rating of 0?",
              "type": "openq",
              "questionID": "NPSw",
              "qNo": 2,
              "visited": true,
              "answerOptions": []
            },
            {
              "answer": null,
              "name": "ewf",
              "answerOptions": [],
              "qNo": 3,
              "questionID": "CONTACT",
              "type": "contactq",
              "ask": "Can we contact you for a follow-up?"
            }
          ],
          "isFromWeb": false,
          "ratingPercentage": 0,
          "for": "2MPS2ywtlubyWS5eCYrXIjsw6vZ2",
          "isSpam": false,
          "showAllInView": false
        },
        {
          "ruAccess": "ZY7tb90oS2MPS2ywtlubyWS5eCYrXIjsw6vZ2nnff7sX48",
          "sessionStartTime": 1603812255,
          "isFromWeb": false,
          "journeyFeedback": [
            {
              "time": 1603812260,
              "answerOptions": null,
              "visited": true,
              "answer": 9,
              "responseID": "anonymousXoiw98b1603812260",
              "questionID": "NPSr",
              "qNo": 1,
              "ask": "How likely would you recommend ewf to others?",
              "type": "ratingq"
            },
            {
              "time": 1603812265,
              "qNo": 2,
              "answerOptions": [],
              "ask": "Please tell us more about your experience online!",
              "visited": true,
              "contactInfo": {
                "businessID": "6t42bmEuZOe2MPS2ywtlubyWS5eCYrXIjsw6vZ2jmCY6B1603797154",
                "website": "",
                "email": "eee@ww.com",
                "contactno": "",
                "businessname": "ewf"
              },
              "answer": null,
              "type": "shareq",
              "responseID": "anonymousXoiw98b1603812265",
              "name": "ewf",
              "questionID": "SHARE",
              "socialOptions": {
                "twitter": "wefew2"
              }
            },
            {
              "type": "openq",
              "responseID": "anonymousXoiw98b1603812267",
              "answer": "wefwe",
              "qNo": 3,
              "questionID": "NPSw",
              "answerOptions": null,
              "time": 1603812267,
              "visited": true,
              "ask": "Why did you give a rating of 9?",
              "staff": true
            },
            {
              "name": "ewf",
              "qNo": 3,
              "type": "contactq",
              "questionID": "CONTACT",
              "answer": null,
              "answerOptions": [],
              "ask": "Can we contact you for a follow-up?"
            }
          ],
          "ratingPercentage": 90,
          "randomString": "SahwraO",
          "rating": 9,
          "sessionID": "1603812265_anonymousXoiw98b",
          "for": "2MPS2ywtlubyWS5eCYrXIjsw6vZ2",
          "isSpam": false,
          "showAllInView": false
        },
        {
          "sessionID": "1603812212_anonymousWFlmBoy",
          "ruAccess": "ZY7tb90oS2MPS2ywtlubyWS5eCYrXIjsw6vZ2nnff7sX48",
          "isFromWeb": false,
          "randomString": "boQpyZb",
          "journeyFeedback": [
            {
              "visited": true,
              "answerOptions": null,
              "questionID": "NPSr",
              "ask": "How likely would you recommend ewf to others?",
              "type": "ratingq",
              "time": 1603812208,
              "responseID": "anonymousWFlmBoy1603812208",
              "qNo": 1,
              "answer": 10
            },
            {
              "answer": null,
              "name": "ewf",
              "time": 1603812212,
              "answerOptions": [],
              "contactInfo": {
                "website": "",
                "email": "eee@ww.com",
                "contactno": "",
                "businessID": "6t42bmEuZOe2MPS2ywtlubyWS5eCYrXIjsw6vZ2jmCY6B1603797154",
                "businessname": "ewf"
              },
              "ask": "Please tell us more about your experience online!",
              "responseID": "anonymousWFlmBoy1603812212",
              "qNo": 2,
              "visited": true,
              "socialOptions": {
                "twitter": "wefew2"
              },
              "type": "shareq",
              "questionID": "SHARE"
            },
            {
              "responseID": "anonymousWFlmBoy1603812215",
              "qNo": 3,
              "questionID": "NPSw",
              "answerOptions": null,
              "answer": "wefwef",
              "time": 1603812215,
              "staff": true,
              "ask": "Why did you give a rating of 10?",
              "type": "openq",
              "visited": true
            },
            {
              "answerOptions": [],
              "questionID": "CONTACT",
              "answer": null,
              "name": "ewf",
              "ask": "Can we contact you for a follow-up?",
              "qNo": 3,
              "type": "contactq"
            }
          ],
          "sessionStartTime": 1603812206,
          "rating": 10,
          "ratingPercentage": 100,
          "for": "2MPS2ywtlubyWS5eCYrXIjsw6vZ2",
          "isSpam": false,
          "showAllInView": false
        },
        {
          "rating": 8,
          "sessionStartTime": 1603799384,
          "randomString": "9kC9AET",
          "ruAccess": "ZY7tb90oS2MPS2ywtlubyWS5eCYrXIjsw6vZ2nnff7sX48",
          "for": "2MPS2ywtlubyWS5eCYrXIjsw6vZ2",
          "journeyFeedback": [
            {
              "answerOptions": null,
              "type": "ratingq",
              "questionID": "NPSr",
              "time": 1603799387,
              "ask": "How likely would you recommend ewf to others?",
              "qNo": 1,
              "responseID": "anonymousrLD6hsj1603799387",
              "answer": 8,
              "visited": true
            },
            {
              "time": 1603799389,
              "ask": "Please tell us more about your experience online!",
              "type": "shareq",
              "responseID": "anonymousrLD6hsj1603799389",
              "contactInfo": {
                "email": "eee@ww.com",
                "businessname": "ewf",
                "website": "",
                "businessID": "6t42bmEuZOe2MPS2ywtlubyWS5eCYrXIjsw6vZ2jmCY6B1603797154",
                "contactno": ""
              },
              "visited": true,
              "answerOptions": [],
              "qNo": 2,
              "socialOptions": {
                "twitter": "wefew2"
              },
              "answer": null,
              "name": "ewf",
              "questionID": "SHARE"
            },
            {
              "answer": "test",
              "ask": "Why did you give a rating of 8?",
              "staff": true,
              "visited": true,
              "questionID": "NPSw",
              "answerOptions": null,
              "type": "openq",
              "qNo": 3,
              "time": 1603799392,
              "responseID": "anonymousrLD6hsj1603799392"
            },
            {
              "ask": "Can we contact you for a follow-up?",
              "qNo": 3,
              "name": "ewf",
              "answerOptions": [],
              "answer": null,
              "type": "contactq",
              "questionID": "CONTACT"
            }
          ],
          "ratingPercentage": 80,
          "isFromWeb": false,
          "sessionID": "1603799389_anonymousrLD6hsj",
          "isSpam": false,
          "showAllInView": false
        },
        {
          "for": "2MPS2ywtlubyWS5eCYrXIjsw6vZ2",
          "isFromWeb": false,
          "rating": 9,
          "ruAccess": "ZY7tb90oS2MPS2ywtlubyWS5eCYrXIjsw6vZ2nnff7sX48",
          "journeyFeedback": [
            {
              "visited": true,
              "qNo": 1,
              "time": 1603799337,
              "ask": "How likely would you recommend ewf to others?",
              "answer": 9,
              "type": "ratingq",
              "questionID": "NPSr",
              "answerOptions": null,
              "responseID": "anonymousEpkSTlc1603799337"
            },
            {
              "socialOptions": {
                "twitter": "wefew2"
              },
              "answer": null,
              "qNo": 2,
              "questionID": "SHARE",
              "name": "ewf",
              "visited": true,
              "time": 1603799339,
              "answerOptions": [],
              "responseID": "anonymousEpkSTlc1603799339",
              "type": "shareq",
              "contactInfo": {
                "contactno": "",
                "businessID": "6t42bmEuZOe2MPS2ywtlubyWS5eCYrXIjsw6vZ2jmCY6B1603797154",
                "email": "eee@ww.com",
                "website": "",
                "businessname": "ewf"
              },
              "ask": "Please tell us more about your experience online!"
            },
            {
              "staff": true,
              "answer": "test",
              "qNo": 3,
              "type": "openq",
              "responseID": "anonymousEpkSTlc1603799343",
              "questionID": "NPSw",
              "answerOptions": null,
              "ask": "Why did you give a rating of 9?",
              "time": 1603799343
            },
            {
              "qNo": 3,
              "ask": "Can we contact you for a follow-up?",
              "answerOptions": [],
              "name": "ewf",
              "type": "contactq",
              "answer": null,
              "questionID": "CONTACT"
            }
          ],
          "sessionID": "1603799339_anonymousEpkSTlc",
          "randomString": "aJ7tHuo",
          "sessionStartTime": 1603799325,
          "ratingPercentage": 90,
          "isSpam": false,
          "showAllInView": false
        },
        {
          "journeyFeedback": [
            {
              "visited": true,
              "type": "ratingq",
              "time": 1603799312,
              "responseID": "anonymousaKAsLIC1603799312",
              "answer": 8,
              "qNo": 1,
              "ask": "How likely would you recommend ewf to others?",
              "answerOptions": null,
              "questionID": "NPSr"
            },
            {
              "answer": null,
              "type": "shareq",
              "ask": "Please tell us more about your experience online!",
              "time": 1603799314,
              "contactInfo": {
                "businessname": "ewf",
                "contactno": "",
                "businessID": "6t42bmEuZOe2MPS2ywtlubyWS5eCYrXIjsw6vZ2jmCY6B1603797154",
                "website": "",
                "email": "eee@ww.com"
              },
              "responseID": "anonymousaKAsLIC1603799314",
              "qNo": 2,
              "answerOptions": [],
              "name": "ewf",
              "questionID": "SHARE",
              "visited": true,
              "socialOptions": {
                "twitter": "wefew2"
              }
            },
            {
              "questionID": "NPSw",
              "staff": true,
              "type": "openq",
              "answer": "test",
              "answerOptions": null,
              "qNo": 3,
              "time": 1603799317,
              "ask": "Why did you give a rating of 8?",
              "responseID": "anonymousaKAsLIC1603799317"
            },
            {
              "questionID": "CONTACT",
              "answer": null,
              "ask": "Can we contact you for a follow-up?",
              "qNo": 3,
              "type": "contactq",
              "answerOptions": [],
              "name": "ewf"
            }
          ],
          "sessionID": "1603799314_anonymousaKAsLIC",
          "sessionStartTime": 1603799192,
          "for": "2MPS2ywtlubyWS5eCYrXIjsw6vZ2",
          "ratingPercentage": 80,
          "isFromWeb": false,
          "rating": 8,
          "ruAccess": "ZY7tb90oS2MPS2ywtlubyWS5eCYrXIjsw6vZ2nnff7sX48",
          "randomString": "hBi6rrH",
          "isSpam": false,
          "showAllInView": false
        },
        {
          "ratingPercentage": 100,
          "sessionID": "1603799106_anonymousuPqLwgb",
          "ruAccess": "ZY7tb90oS2MPS2ywtlubyWS5eCYrXIjsw6vZ2nnff7sX48",
          "isFromWeb": false,
          "journeyFeedback": [
            {
              "time": 1603799105,
              "responseID": "anonymousuPqLwgb1603799105",
              "qNo": 1,
              "visited": true,
              "ask": "How likely would you recommend ewf to others?",
              "questionID": "NPSr",
              "answerOptions": null,
              "answer": 10,
              "type": "ratingq"
            },
            {
              "socialOptions": {
                "twitter": "wefew2"
              },
              "questionID": "SHARE",
              "visited": true,
              "type": "shareq",
              "ask": "Please tell us more about your experience online!",
              "time": 1603799106,
              "qNo": 2,
              "name": "ewf",
              "answer": null,
              "contactInfo": {
                "businessID": "6t42bmEuZOe2MPS2ywtlubyWS5eCYrXIjsw6vZ2jmCY6B1603797154",
                "email": "eee@ww.com",
                "contactno": "",
                "website": "",
                "businessname": "ewf"
              },
              "answerOptions": [],
              "responseID": "anonymousuPqLwgb1603799106"
            },
            {
              "qNo": 3,
              "type": "openq",
              "answer": "wefw",
              "visited": true,
              "time": 1603799156,
              "answerOptions": null,
              "questionID": "NPSw",
              "ask": "Why did you give a rating of 10?",
              "responseID": "anonymousuPqLwgb1603799156",
              "staff": true
            },
            {
              "type": "contactq",
              "name": "ewf",
              "answer": null,
              "ask": "Can we contact you for a follow-up?",
              "qNo": 3,
              "questionID": "CONTACT",
              "answerOptions": []
            }
          ],
          "sessionStartTime": 1603799103,
          "for": "2MPS2ywtlubyWS5eCYrXIjsw6vZ2",
          "rating": 10,
          "randomString": "JiI2INC",
          "isSpam": false,
          "showAllInView": false
        },
        {
          "for": "2MPS2ywtlubyWS5eCYrXIjsw6vZ2",
          "journeyFeedback": [
            {
              "visited": true,
              "answerOptions": null,
              "type": "ratingq",
              "ask": "How likely would you recommend ewf to others?",
              "time": 1603799073,
              "responseID": "anonymousT401kfs1603799073",
              "qNo": 1,
              "questionID": "NPSr",
              "answer": 9
            },
            {
              "type": "shareq",
              "responseID": "anonymousT401kfs1603799074",
              "socialOptions": {
                "twitter": "wefew2"
              },
              "answer": null,
              "time": 1603799074,
              "name": "ewf",
              "qNo": 2,
              "visited": true,
              "answerOptions": [],
              "contactInfo": {
                "businessname": "ewf",
                "website": "",
                "email": "eee@ww.com",
                "businessID": "6t42bmEuZOe2MPS2ywtlubyWS5eCYrXIjsw6vZ2jmCY6B1603797154",
                "contactno": ""
              },
              "ask": "Please tell us more about your experience online!",
              "questionID": "SHARE"
            },
            {
              "ask": "Why did you give a rating of 9?",
              "type": "openq",
              "questionID": "NPSw",
              "staff": true,
              "answer": null,
              "qNo": 3,
              "answerOptions": null
            },
            {
              "qNo": 3,
              "questionID": "CONTACT",
              "name": "ewf",
              "ask": "Can we contact you for a follow-up?",
              "answer": null,
              "type": "contactq",
              "answerOptions": []
            }
          ],
          "ratingPercentage": 90,
          "ruAccess": "ZY7tb90oS2MPS2ywtlubyWS5eCYrXIjsw6vZ2nnff7sX48",
          "randomString": "FVPvYRi",
          "sessionID": "1603799074_anonymousT401kfs",
          "rating": 9,
          "sessionStartTime": 1603799071,
          "isFromWeb": false,
          "isSpam": false,
          "showAllInView": false
        }
      ],
      "furthestBackTime": 1603799071,
      "initialLoadLimit": 60
    }
  },
  "viewState": {
    "initialFeedbackLoaded": true,
    "filters": {
      "view": {
        "startTime": 1603799071,
        "endTime": 1608193694,
        "pageIndex": 1,
        "numberOfPages": 2,
        "questionID": null,
        "directComplaint": true,
        "sentiment": {
          "positive": true,
          "neutral": true,
          "negative": true
        },
        "spam": false,
        "text": ""
      },
      "question": {
        "startTime": 1608193694,
        "endTime": 1608193694,
        "sentiment": {
          "positive": true,
          "neutral": true,
          "negative": true
        },
        "spam": false,
        "text": ""
      }
    },
    "selectedScorePeriod": "7",
    "checkedShares": [],
    "entityLoaded": true,
    "processingPayment": false,
    "modal": false,
    "selectedShare": false,
    "selectedSharesview": [],
    "selectedShareslist": [],
    "selectedShareslistName": "",
    "selectedSharesquestion": [],
    "selectedShareslistListID": "",
    "loadingShareLink": false,
    "currentShareLink": false,
    "loadingFullScreen": false,
    "loadingFeedback": false,
    "modalConfirmation": false,
    "showPreview": false,
    "noFilteredSessions": {
      "question": false,
      "list": false,
      "view": false
    },
    "selectedResponse": false,
    "section": "feedback",
    "page": "view",
    "currentQuestion": false,
    "currentList": false,
    "isExampleFeedback": false,
    "notificationText": false
  }
}


  */
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  'LOAD_ADDNEW_STATE' (state) {
    //noconsoleconsole.log('loading setup state')
    //noconsoleconsole.log(state.dash)
    //noconsoleconsole.log(state.signUpState)

    //THIS WILL NEED TO BE CHANGED TO VIEWDATA1!!

    state.signUpState.recorded.appearance.logoUrl = state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.logoUrl
    state.signUpState.recorded.businessInfo.webAddress = state.dash.viewData.business.publicFeedbackDetail.entityInfo.webAddress
    //noconsoleconsole.log(state.signUpState.recorded.appearance.logoUrl)
    //noconsoleconsole.log(state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.logoUrl)
    state.signUpState.recorded.appearance.backgroundHex = state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.backgroundHex
    state.signUpState.recorded.appearance.secondaryHex = state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.secondaryHex

    state.signUpState.recorded.socialMediaReviews.facebook = state.dash.viewData.business.externalPlatforms.fb ? typeof state.dash.viewData.business.externalPlatforms.fb.id !== "undefined" ? state.dash.viewData.business.externalPlatforms.fb.id : '' : ''
    state.signUpState.recorded.socialMediaReviews.twitter = state.dash.viewData.business.externalPlatforms.tw ? state.dash.viewData.business.externalPlatforms.tw.id !== "undefined" ? state.dash.viewData.business.externalPlatforms.tw.id : '' : ''
    state.signUpState.recorded.socialMediaReviews.trustPilot = state.dash.viewData.business.externalPlatforms.tp ? state.dash.viewData.business.externalPlatforms.tp.id !== "undefined" ? state.dash.viewData.business.externalPlatforms.tp.id : '' : ''
    state.signUpState.recorded.socialMediaReviews.g2 = state.dash.viewData.business.externalPlatforms.g2 ? state.dash.viewData.business.externalPlatforms.g2.id !== "undefined" ? state.dash.viewData.business.externalPlatforms.g2.id : '' : ''
    state.signUpState.recorded.socialMediaReviews.capterra = state.dash.viewData.business.externalPlatforms.ca ? state.dash.viewData.business.externalPlatforms.ca.id !== "undefined" ? state.dash.viewData.business.externalPlatforms.ca.id : '' : ''
    state.signUpState.recorded.socialMediaReviews.tripAdvisor = state.dash.viewData.business.externalPlatforms.ta ? state.dash.viewData.business.externalPlatforms.ta.id !== "undefined" ? state.dash.viewData.business.externalPlatforms.ta.id : '' : ''
    state.signUpState.recorded.socialMediaReviews.yelp = state.dash.viewData.business.externalPlatforms.ye ? state.dash.viewData.business.externalPlatforms.ye.id !== "undefined" ? state.dash.viewData.business.externalPlatforms.ye.id : '' : ''
    state.signUpState.recorded.socialMediaReviews.fourSquare = state.dash.viewData.business.externalPlatforms.fs ? state.dash.viewData.business.externalPlatforms.fs.id !== "undefined" ? state.dash.viewData.business.externalPlatforms.fs.id : '' : ''

    /*

    "facebook": "",
    "twitter": "",
    "googleMaps": "",
    "trustPilot": "",
    "g2": "",
    "capterra": "",
    "tripAdvisor": "",
    "yelp": "",
    "fourSquare": "",
    "chooseFbS": false,
    "chooseFbR": false,
    "chooseTw": false,
    "chooseGP": false,
    "chooseTP": false,
    "chooseG2": false,
    "chooseCT": false,
    "chooseTA": false,
    "chooseYE": false,
    "chooseFS": false

    */

  },

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE (state, value) {
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON (state, val) {
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE (state, val) {
    state.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN (state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH (state, width) {
    state.verticalNavMenuWidth = width
  },


  // VxAutoSuggest

  UPDATE_STARRED_PAGE (state, payload) {

    // find item index in search list state
    const index = state.navbarSearchAndPinList['pages'].data.findIndex((item) => item.url === payload.url)

    // update the main list
    state.navbarSearchAndPinList['pages'].data[index].is_bookmarked = payload.val

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList['pages'].data[index])
    } else {
      // find item index from starred pages
      const index = state.starredPages.findIndex((item) => item.url === payload.url)

      // remove item using index
      state.starredPages.splice(index, 1)
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED (state, list) {
    const starredPagesMore = state.starredPages.slice(10)
    state.starredPages     = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE (state, list) {
    let downToUp                   = false
    const lastItemInStarredLimited = state.starredPages[10]
    const starredPagesLimited      = state.starredPages.slice(0, 10)
    state.starredPages             = starredPagesLimited.concat(list)

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited)
    }
  },


  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY (state, val) { state.bodyOverlay       = val   },
  UPDATE_PRIMARY_COLOR (state, val)   { state.themePrimaryColor = val   },
  UPDATE_THEME (state, val)           { state.theme             = val   },
  UPDATE_WINDOW_WIDTH (state, width)  { state.windowWidth       = width },
  UPDATE_WINDOW_SCROLL_Y (state, val) { state.scrollY           = val   },


  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // Updates user info in state and localstorage
  UPDATE_USER_INFO (state, payload) {

    // Get Data localStorage
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || state.AppActiveUser

    for (const property of Object.keys(payload)) {

      if (payload[property] !== null) {
        // If some of user property is null - user default property defined in state.AppActiveUser
        state.AppActiveUser[property] = payload[property]

        // Update key in localStorage
        userInfo[property] = payload[property]
      }


    }
    // Store data in localStorage
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  }
}

export default mutations
